module.exports = __webpack_public_path__ + "static/img/FASHION_ACC.a43f819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FASHION_ACC.jpg
// module id = 4sqE
// module chunks = 1